import React from 'react'
import BranchCreate from '../branch_components/branch_create'

export default function Main() {
  return <BranchCreate />
}
